// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DiscrepancyChat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.DiscrepancyChat header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.DiscrepancyChat header h3 {
  font-size: 1rem;
  color: var(--TextColor);
  font-weight: 700;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.DiscrepancyChat header h3 div {
  border-left: 0.0625rem solid var(--Stroke);
  padding-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.DiscrepancyChat header h3 div svg {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.DiscrepancyChat header h3 div svg:hover {
  transform: rotate(180deg);
}
.DiscrepancyChat header button {
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  color: var(--TextColor);
  font-size: 0.75rem;
  cursor: pointer;
}
.DiscrepancyChat header .ViewResume {
  color: var(--AccentColor);
  border-left: 0.0625rem solid var(--Stroke);
  gap: 0.375rem;
}
.DiscrepancyChat .ChatSection {
  flex: 1 1;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.75rem;
  overflow: auto;
  margin: 0.5rem;
}
.DiscrepancyChat .ChatSection .MessageSec {
  max-width: 75%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Logo {
  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;
  border-radius: 0.5rem;
  background: var(--Invitation);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 0.0625rem solid var(--Stroke);
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Logo .Initial {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Message {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  border-radius: 0.5rem;
  padding: 0.25rem 0.5rem;
  border: 0.0625rem solid var(--Stroke);
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Message .UserName {
  font-size: 0.625rem;
  font-weight: 700;
  color: var(--AccentColor);
}
.DiscrepancyChat .ChatSection .MessageSec .LogoMessage .Message .msgText {
  font-size: 0.75rem;
  color: var(--TextColor);
  word-break: break-word;
  hyphens: auto;
}
.DiscrepancyChat .ChatSection .MessageSec .Time {
  font-size: 0.625rem;
  color: #9b9b9b;
}
.DiscrepancyChat .ChatSection .Sender {
  align-items: flex-start;
  align-self: flex-start;
}
.DiscrepancyChat .ChatSection .Sender .LogoMessage .Message {
  align-items: flex-start;
  background: var(--Invitation);
}
.DiscrepancyChat .ChatSection .Receiver {
  align-items: flex-end;
  align-self: flex-end;
}
.DiscrepancyChat .ChatSection .Receiver .LogoMessage .Message {
  align-items: flex-end;
}
.DiscrepancyChat .ChatEnded {
  border-top: 0.0625rem solid var(--Stroke);
  padding: 0.5rem;
  font-size: 0.75rem;
  text-align: center;
  color: var(--TextColor);
}
.DiscrepancyChat .MsgConclude {
  padding: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.DiscrepancyChat .MsgConclude .MessageInput {
  flex: 1 1;
  height: 2rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.25rem;
  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.DiscrepancyChat .MsgConclude .MessageInput input {
  flex: 1 1;
  height: 100%;
  border: none;
  background: none;
  color: var(--TextColor);
}
.DiscrepancyChat .MsgConclude .MessageInput .Send {
  width: 4rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  background: var(--AccentColor);
  color: #ffffff;
  font-size: 0.75rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}
.DiscrepancyChat .MsgConclude .ConcludeButton {
  border: 0.0625rem solid var(--Stroke);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  height: 2rem;
  color: var(--TextColor);
  cursor: pointer;
  width: 4.5rem;
  background: var(--Invitation);
}
.DiscrepancyChat .MsgConclude .ConcludeModalCont {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(167, 167, 167, 0.5);
  backdrop-filter: blur(3px);
  z-index: 2;
}
.DiscrepancyChat .MsgConclude .ConcludeModalCont .ConcludeModal {
  display: flex;
  flex-direction: column;
  width: 20rem;
  border-radius: 0.75rem;
}
.DiscrepancyChat .MsgConclude .ConcludeModalCont .ConcludeModal header {
  border-radius: 0.75rem 0.75rem 0 0;
  padding: 0.5rem 0.75rem;
  background: var(--AccentColor);
  display: flex;
  align-items: center;
  gap: 1rem;
}
.DiscrepancyChat .MsgConclude .ConcludeModalCont .ConcludeModal header h3 {
  color: #ffffff;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/AdminCvAnalysis/DiscrepancyChat.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,4CAAA;AAEJ;AADI;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAFM;EACE,0CAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAIR;AAHQ;EACE,eAAA;EACA,gCAAA;AAKV;AAJU;EACE,yBAAA;AAMZ;AADI;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAGN;AADI;EACE,yBAAA;EACA,0CAAA;EACA,aAAA;AAGN;AAAE;EACE,SAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AAEJ;AADI;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;AAGN;AAFM;EACE,aAAA;EACA,qBAAA;EACA,WAAA;AAIR;AAHQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qCAAA;AAKV;AAJU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAMZ;AAJU;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;AAMZ;AAHQ;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qCAAA;AAKV;AAJU;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;AAMZ;AAJU;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;AAMZ;AAFM;EACE,mBAAA;EACA,cAAA;AAIR;AADI;EACE,uBAAA;EACA,sBAAA;AAGN;AADQ;EACE,uBAAA;EACA,6BAAA;AAGV;AACI;EACE,qBAAA;EACA,oBAAA;AACN;AACQ;EACE,qBAAA;AACV;AAIE;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;AAFJ;AAIE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAFJ;AAGI;EACE,SAAA;EACA,YAAA;EACA,qCAAA;EACA,sBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AADN;AAEM;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAAR;AAEM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAAR;AAGI;EACE,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AADN;AAGI;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,0BAAA;EACA,UAAA;AADN;AAEM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AAAR;AACQ;EACE,kCAAA;EACA,uBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACV;AAAU;EACE,cAAA;EACA,eAAA;AAEZ","sourcesContent":[".DiscrepancyChat{\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  header{\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.25rem;\n    border-bottom: 0.0625rem solid var(--Stroke);\n    h3{\n      font-size: 1rem;\n      color: var(--TextColor);\n      font-weight: 700;\n      flex: 1;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      div{\n        border-left: 0.0625rem solid var(--Stroke);\n        padding-left: 0.5rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        svg{\n          cursor: pointer;\n          transition: all 0.3s ease-in-out;\n          &:hover {\n            transform: rotate(180deg);\n          }\n        }\n      }\n    }\n    button {\n      border: none;\n      background: none;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.25rem;\n      color: var(--TextColor);\n      font-size: 0.75rem;\n      cursor: pointer;\n    }\n    .ViewResume {\n      color: var(--AccentColor);\n      border-left: 0.0625rem solid var(--Stroke);\n      gap: 0.375rem;\n    }\n  }\n  .ChatSection{\n    flex: 1;\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.75rem;\n    overflow: auto;\n    margin: 0.5rem;\n    .MessageSec{\n      max-width: 75%;\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n      gap: 0.25rem;\n      .LogoMessage{\n        display: flex;\n        align-items: flex-end;\n        gap: 0.5rem;\n        .Logo{\n          width: 2rem;\n          height: 2rem;\n          min-width: 2rem;\n          min-height: 2rem;\n          border-radius: 0.5rem;\n          background: var(--Invitation);\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          overflow: hidden;\n          border: 0.0625rem solid var(--Stroke);\n          img{\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            object-position: center;\n          }\n          .Initial{\n            font-size: 1.5rem;\n            font-weight: 700;\n            color: var(--AccentColor);\n          }\n        }\n        .Message{\n          display: flex;\n          flex-direction: column;\n          align-items: flex-end;\n          border-radius: 0.5rem;\n          padding: 0.25rem 0.5rem;\n          border: 0.0625rem solid var(--Stroke);\n          .UserName{\n            font-size: 0.625rem;\n            font-weight: 700;\n            color: var(--AccentColor);\n          }\n          .msgText{\n            font-size: 0.75rem;\n            color: var(--TextColor);\n            word-break: break-word;\n            hyphens: auto;\n          }\n        }\n      }\n      .Time{\n        font-size: 0.625rem;\n        color: #9b9b9b;\n      }\n    }\n    .Sender{\n      align-items: flex-start;\n      align-self: flex-start;\n      .LogoMessage{\n        .Message{\n          align-items: flex-start;\n          background: var(--Invitation);\n        }\n      }\n    }\n    .Receiver{\n      align-items: flex-end;\n      align-self: flex-end;\n      .LogoMessage{\n        .Message{\n          align-items: flex-end;\n        }\n      }\n    }\n  }\n  .ChatEnded{\n    border-top: 0.0625rem solid var(--Stroke);\n    padding: 0.5rem;\n    font-size: 0.75rem;\n    text-align: center;\n    color: var(--TextColor);\n  }\n  .MsgConclude{\n    padding: 0.5rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    .MessageInput{\n      flex: 1;\n      height: 2rem;\n      border: 0.0625rem solid var(--Stroke);\n      border-radius: 0.25rem;\n      padding: 0.25rem 0.25rem 0.25rem 0.5rem;\n      display: flex;\n      align-items: center;\n      gap: 0.5rem;\n      input{\n        flex: 1;\n        height: 100%;\n        border: none;\n        background: none;\n        color: var(--TextColor);\n      }\n      .Send{\n        width: 4rem;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.25rem;\n        background: var(--AccentColor);\n        color: #ffffff;\n        font-size: 0.75rem;\n        border: none;\n        border-radius: 0.25rem;\n        cursor: pointer;\n      }\n    }\n    .ConcludeButton{\n      border: 0.0625rem solid var(--Stroke);\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 0.25rem;\n      font-size: 0.75rem;\n      height: 2rem;\n      color: var(--TextColor);\n      cursor: pointer;\n      width: 4.5rem;\n      background: var(--Invitation);\n    }\n    .ConcludeModalCont{\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: rgba(167, 167, 167, 0.50);\n      backdrop-filter: blur(3px);\n      z-index: 2;\n      .ConcludeModal{\n        display: flex;\n        flex-direction: column;\n        width: 20rem;\n        border-radius: 0.75rem;\n        header{\n          border-radius: 0.75rem 0.75rem 0 0;\n          padding: 0.5rem 0.75rem;\n          background: var(--AccentColor);\n          display: flex;\n          align-items: center;\n          gap: 1rem;\n          h3{\n            color: #ffffff;\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
